import React from 'react';
import { Link } from 'react-router-dom';
import MetaTagsUpdater from "../../components/MetaTagsUpdater";

function NotFound() {
  return (
      <>
        <MetaTagsUpdater pageKey="NotFound" />
        <div className="flex items-center justify-center min-h-screen bg-bg-dark text-text-white px-4">
          <div className="text-center">
            <h1 className="text-9xl font-bold text-accent-red">404</h1>
            <h2 className="text-4xl font-semibold text-text-white mb-4">Page Not Found</h2>
            <p className="text-lg text-text-gray mb-8">
              Oops! The page you are looking for does not exist. It might have been moved or deleted.
            </p>
            <Link
                to="/"
                className="bg-accent-red text-text-white rounded-full px-6 py-3 text-lg font-medium transition-all duration-300 hover:bg-red-700 hover:-translate-y-0.5 no-underline"
            >
              Go to Homepage
            </Link>
          </div>
        </div>
      </>
  );
}

export default NotFound;